package org.hs_soft.runmynesto.domain.usecase.options.restaurant_manager

import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.create_update_room.CreateUpdateRestaurantRoomModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.CreateRoomRepository

class CreateRoomUseCase(
    private val repository: CreateRoomRepository,
) {
    suspend operator fun invoke(
        caption:String,
        floorId:String,
        projectId:String,
    ): CreateUpdateRestaurantRoomModel {
        return repository.createRoom(
            caption=caption,
            floorId=floorId,
            projectId=projectId
        )
    }
}